import type { Role, SessionInfo } from '@numistic/contracts'
import { sessionQuery } from '@numistic/data'
import { redirect, type ParsedLocation } from '@tanstack/react-router'

import type { RouterContext } from './context.js'

export async function loadSession(context: RouterContext): Promise<SessionInfo | null> {
  try {
    return await context.queryClient.ensureQueryData(sessionQuery(context.dataClient))
  } catch {
    return null
  }
}

/** Для закрытых роутов: без сессии — на вход с возвратом обратно. */
export async function requireSession(
  context: RouterContext,
  location: ParsedLocation,
): Promise<SessionInfo> {
  const session = await loadSession(context)
  if (!session) {
    throw redirect({ to: '/login', search: { redirect: location.href } })
  }
  return session
}

export async function requireRole(
  context: RouterContext,
  location: ParsedLocation,
  ...roles: Role[]
): Promise<SessionInfo> {
  const session = await requireSession(context, location)
  if (!roles.includes(session.user.role)) {
    throw redirect({ to: '/' })
  }
  return session
}

/** Разрешены только локальные пути — защита от open redirect через ?redirect=. */
export function safeRedirect(target: string | undefined): string {
  return target && target.startsWith('/') && !target.startsWith('//') ? target : '/'
}
